"use strict";
/**
 * @enum AddRemove
 * @description Defines the values for the add remove attribute
 * for the update investments lambda
 */
exports.__esModule = true;
exports.AddRemove = void 0;
var AddRemove;
(function (AddRemove) {
    AddRemove["add"] = "add";
    AddRemove["remove"] = "remove";
})(AddRemove = exports.AddRemove || (exports.AddRemove = {}));
